import {
  AtlasBodyMain,
  AtlasCaption,
  AtlasColor,
  CardComponent
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { StackAtom } from 'components/atoms/Stack.atom'

interface TransferPalletCardOrganismProps {
  container: string
  palletNumber: number
  totalPallets: number
  channel: string
  currentPallet?: boolean
  palletScanned?: boolean
  palletReady?: boolean
}

export const TransferPalletCardOrganism = (
  props: TransferPalletCardOrganismProps
) => {
  const {
    container,
    palletNumber,
    totalPallets,
    channel,
    currentPallet = false,
    palletScanned = false,
    palletReady = false
  } = props

  const highlightContainer = currentPallet && !palletScanned

  return (
    <CardComponent
      style={{
        padding: '12px',
        borderColor:
          currentPallet && !palletReady ? AtlasColor.Primary00 : '#5C5C5C'
      }}
    >
      <StackAtom $gap={4} $align="center">
        <CardComponent
          $variant="highlight"
          style={{
            padding: '8px 12px',
            width: 'fit-content',
            background: palletReady
              ? '#292929'
              : highlightContainer
                ? '#3C2E02'
                : '#424242'
          }}
        >
          <StackAtom $direction="column" $gap={12}>
            <AtlasCaption
              style={{
                color: palletReady
                  ? '#5C5C5C'
                  : highlightContainer
                    ? AtlasColor.Primary00
                    : '#999',
                fontWeight: 700
              }}
            >
              {`Tarima ${palletNumber} de ${totalPallets}`}
            </AtlasCaption>

            <StackAtom $gap={4} $align="center">
              <Icon
                name="ic_scan_qr"
                color={
                  palletReady
                    ? AtlasColor.BackgroundTap
                    : highlightContainer
                      ? '#FDF0C3'
                      : 'white'
                }
                size={18}
              />

              <AtlasBodyMain
                style={{
                  fontWeight: 700,
                  color: palletReady
                    ? '#5C5C5C'
                    : highlightContainer
                      ? '#FDF0C3'
                      : '#E0E0E0'
                }}
              >
                {container}
              </AtlasBodyMain>
            </StackAtom>
          </StackAtom>
        </CardComponent>

        <Icon name="arrow" size={18} color="white" />

        <CardComponent
          $variant="highlight"
          style={{
            width: 'fit-content',
            justifyContent: 'center',
            display: 'flex',
            background: palletReady
              ? '#292929'
              : palletScanned
                ? '#3C2E02'
                : '#424242'
          }}
        >
          <AtlasCaption
            style={{
              color: palletReady
                ? '#5C5C5C'
                : palletScanned
                  ? AtlasColor.Primary00
                  : '#FFF'
            }}
          >
            {channel}
          </AtlasCaption>
        </CardComponent>

        <Icon
          name={palletReady ? 'ic_check_circle_fill' : 'ic_check_circle_dark'}
          color={palletReady ? '#21C043' : '#7A7A7A'}
          size={24}
        />
      </StackAtom>
    </CardComponent>
  )
}
